import{appCtxComponentId as e,appCtxLoaderData as t,appCtxRenderMode as n}from"./constants.js";const r={install(r,i,a,o){r.provide(e,i).provide(n,a).provide(t,o)}};export{r as appContextPlugin};
//# sourceMappingURL=appContext.js.map